import React, { useState, useEffect } from "react";

import Select from "../../select/select_v2";

import Button from "../../button/button_v2";
import api from "../../../services/api";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import { store } from "react-notifications-component";
import { Container } from "react-grid-system";
import Input from "../../input/input_v2";

import ModalText from "../../modal/modalText";
import { FormContainer } from "./styles";

import AddAgronomo from "../../../pages/agronomos/add";
import Modal from "../../modal/modalGeneric";

import estados from "../../../services/estados";
import { Row, Col, Hidden } from "react-grid-system";
import { isTotvs } from "../../../services/globalFunctions";

const MENSAGEM_NUMERO_ART_RS =
  "O número da ART deve ter 7 a 10 caracteres (ex: 1234567890).";

const isNumeroArtRsValido = (valor) =>
  /^[A-Za-z0-9]{7,10}$/.test(String(valor || "").trim());

const ArtsOne = ({ ...props }) => {
  const { update, next } = props;
  const [agronomoId, setAgronomoId] = useState("");
  const [estadoId, setEstado] = useState("");
  const [creaId, setCreaId] = useState("");
  const [agronomos, setAgronomos] = useState([]);
  const [creas, setCreas] = useState([]);
  // const [filialId, setFilialId] = useState("");
  const [max, setMax] = useState("");
  const [numeroArt, setNumeroArt] = useState("");
  const [receitaInicial, setReceitaInicial] = useState("");
  const [quantidadeReceita, setQuantidadeReceita] = useState("");
  const [quantidadeContratos, setQuantidadeContratos] = useState("");
  const [numeroOrdem, setNumeroOrdem] = useState("");
  const [apelido, setApelido] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [step] = useState(1);
  const [valorInformacao, setValorInformacao] = useState("");
  const [modalAgronomoShow, setModalAgronomoShow] = useState(false);
  const [modalCreaShow, setModalCreaShow] = useState(false);
  // const [nomeId, setNomeId] = useState('');
  // const [cpfId, setCpfId] = useState('');
  const [passo3, setPasso3] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModalValidade, setShowModalValidade] = useState(false);
  const [placeholderCfta, setPlaceholderCFTA] = useState("");
  const [placeholderTrt, setPlaceholderTRT] = useState("");

  // Checagem de duplicidade por CREA + número ART/TRT antes de criar
  const checkDuplicateArt = async (creaIdParam, numeroArtParam, estadoParam) => {
    try {
      const payload = { search: numeroArtParam, estado: estadoParam };
      const response = await api.post(`/art/pesquisa?limit=1&offset=0`, payload);
      const arts = response?.data?.data?.arts || [];
      const targetCreaId = (creaIdParam && creaIdParam.value) || creaIdParam;

      const duplicate = arts.some(
        (a) =>
          a?.numero_art === numeroArtParam &&
          ((a?.crea && a.crea.id === targetCreaId) || a?.crea_id === targetCreaId)
      );

      return duplicate;
    } catch (e) {
      return false;
    }
  };

  const [erroNumeroArt, setErroNumeroArt] = useState(false);
  const [erroCreaId, setErroCreaId] = useState(false);
  const [erroAgronomoId, setErroAgronomoId] = useState(false);
  const [erroReceitaInicial, setErroReceitaInicial] = useState(false);
  const [erroReceitasEmitidas, setErroReceitasEmitidas] = useState(false);
  const [erroQuantidadeContratos, setErroQuantidadeContratos] = useState(false);
  const [erroNumeroOrdem, setErroNumeroOrdem] = useState(false);

  const destacarCampoDoErroDaApi = (erro) => {
    if (typeof erro !== "string") return;

    if (["ERRO-155", "ERRO-156", "ERRO-680"].some((codigo) => erro.includes(codigo))) {
      setErroNumeroArt(true);
      setErroReceitaInicial(false);
      return;
    }

    if (
      ["ERRO-157", "ERRO-158", "ERRO-159", "ERRO-160", "ERRO-161", "ERRO-162", "ERRO-165", "ERRO-681"]
        .some((codigo) => erro.includes(codigo))
    ) {
      setErroNumeroArt(false);
      setErroReceitaInicial(true);
    }
  };

  const [qtdReceitasEmitidas, setQtdReceitasEmitidas] = useState("0");

  const [loading, setLoading] = useState(false);
  const [inativoSaldoArt, setInativoSaldoArt] = useState(false);

  const [legendaQuantidade, setLegendaQuantidade] = useState("");
  const [saldoArts, setSaldoArts] = useState(null);

  const [sendAlert, setSendAlert] = useState(true);

  const [dataValidade, setDataValidade] = useState("");

  const [estadosReceitaInicialAlfanumerica, setEstadosReceitaInicialAlfanumerica] = useState([]);

  // let maska = "A";

  const formatAgronomo = (agronomos) => {
    agronomos = agronomos.map((agronomo) => {
      const format = {
        value: agronomo.id,
        label: agronomo.nome,
      };

      return format;
    });

    return agronomos;
  };
  const formatCreas = (creas) => {
    creas = creas.map((crea) => {
      const format = {
        value: crea.id,
        label: crea.crea,
      };
      return format;
    });
    return creas;
  };

  const getAgronomos = async (valor) => {
    // const response = await api.get(`/agronomos?status=1&estado=${valor}`);
    if (valor) {
      let agronomosByState = [];

      const response = await api.get(`/agronomos/estado/${valor}?action=new`);
      let agronomos = response.data.data;
      setEstadosReceitaInicialAlfanumerica(response.data.estadosVarchar)

      agronomos = formatAgronomo(agronomos);
      setAgronomos(agronomos);
    }
  };

  const getCreas = async (agronomoId, valor) => {
    // setCreas([{ label: "Não encontrado" }]);
    if (agronomoId && valor) {
      try {
        const response = await api.get(
          `/agronomos/${agronomoId.value || agronomoId || "*"}/creas?&estado=${valor || "*"
          }`
        );
        let creas = response.data.data;
        creas = formatCreas(creas);
        setCreas(creas);
      } catch (error) { }
    }
  };
  const getMax = async (valor) => {
    if (valor) {
      try {
        const response = await api.get(`/maxcontratos/${valor}`);
        const max = response.data.data;
        setMax(max);
      } catch (error) { }
    }
  };
  const testaArt = async () => {
    try {
      if (!numeroArt || String(numeroArt).trim() === "") {
        return true;
      }

      setErroNumeroArt(false);

      const response = await api.get(`/arts`);
      const arts = response.data.data;

      let isError = false;

      arts.map((art) => {
        if (numeroArt === art.numero_art) {
          if (agronomoId === art.crea.agronomo.id) {
            isError = true;
          }
        }
      });

      if (isError === true) {
        setErroNumeroArt(true);

        store.addNotification({
          title: "Erro!",
          message: "Esse número de ART/TRT já esta Cadastrado.",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 6000,
            onScreen: true,
          },
        });
        return false;
      } else {
        setErroNumeroArt(false);
        return true;
      }
    } catch (error) {
      setErroNumeroArt(false);
      return true;
    }
  };

  const handlePost = async (e) => {
    // e.preventDefault();
    setLoading(true);
    setEstado(props.estado.value);

    const valor = props.estado.value || props.estado;

    if (valor === "RS" && numeroArt && !isNumeroArtRsValido(numeroArt)) {
      setErroNumeroArt(true);
      store.addNotification({
        title: "Erro!",
        message: MENSAGEM_NUMERO_ART_RS,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 6000,
          onScreen: true,
        },
      });
      setLoading(false);
      return;
    }

    // let inputWithErrors = document.querySelectorAll(".error");

    // for (let input of inputWithErrors) {
    //     input.classList.remove("error");
    // }

    if (valor === "SP") {
      if (
        !creaId ||
        !agronomoId ||
        !numeroArt ||
        !receitaInicial ||
        !quantidadeContratos ||
        !numeroOrdem
      ) {
        if (!creaId) {
          setErroCreaId(true);
        }

        if (!agronomoId) {
          setErroAgronomoId(true);
        }

        if (!numeroArt) {
          setErroNumeroArt(true);
        }

        if (!receitaInicial) {
          setErroReceitaInicial(true);
        }

        if (!quantidadeContratos) {
          setErroQuantidadeContratos(true);
        }

        if (!quantidadeReceita) {
          setErroQuantidadeContratos(true);
        }

        if (!numeroOrdem) {
          setErroNumeroOrdem(true);
        }

        store.addNotification({
          title: "Erro!",
          message: "Preencha os campos em vermelho para continuar",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 6000,
            onScreen: true,
          },
        });

        setLoading(false);
        return;
      } else {
        // Checa duplicidade antes de criar (SP)
        const isDuplicate = await checkDuplicateArt(creaId, numeroArt, valor);
        if (isDuplicate) {
          setErroNumeroArt(true);
          store.addNotification({
            title: "Erro!",
            message: "Esse número de ART/TRT já existe para o CREA selecionado.",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 6000, onScreen: true },
          });
          setLoading(false);
          return;
        }

        const payload = {
          estado: valor,
          creaId: creaId.value || creaId,
          agronomoId: agronomoId.value || agronomoId,
          apelido: apelido || null,
          numero_art: numeroArt,
          quantidade_receitas: Number(quantidadeReceita),
          receita_inicial: receitaInicial,
          quantidade_contratos: quantidadeContratos,
          numero_ordem: numeroOrdem,
          data_validade: dataValidade,
        };

        try {
          const response = await api.post(
            `/creas/${creaId.value || creaId}/arts`,
            payload
          );

          if (response.status === 200) {
            store.addNotification({
              title: "Sucesso!",
              message: "O ART foi cadastrado corretamente.",
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true,
              },
            });
          }

          if (props.isModal === true) {
            props.updateArt();
          } else {
            props.loc.history.push("/arts");
          }
        } catch (err) {
          const ERRO = err.response?.data?.errors;
          const status = err.response?.status;
          const apiErrorMessage = identifyErrorMenssage(
            err,
            "Erro ao cadastrar ART/TRT."
          );
          const validationErrorMessage = identifyErrorMenssage(
            err,
            "Verifique os campos em vermelho"
          );
          destacarCampoDoErroDaApi(ERRO);
          if (status === 406 || status === 400) {
            store.addNotification({
              title: "Erro!",
              message: apiErrorMessage,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
            setLoading(false);
          } else {
            try {
              let inputWithErrors = document.querySelectorAll(".error");

              for (let input of inputWithErrors) {
                // input.classList.remove("error");

                if (input === "creaId") {
                  setErroCreaId(false);
                } else if (input === "agronomoId") {
                  setErroAgronomoId(false);
                } else if (input === "numero_art") {
                  setErroNumeroArt(false)
                } else if (input === "receita_inicial") {
                  setErroReceitaInicial(false);
                } else if (input === "quantidade_receitas") {
                  setErroQuantidadeContratos(false);
                }
              }

              const errors = err.response?.data?.errors;

              for (let field in errors) {
                // const input = document.getElementById(field);
                // input.classList.add("error");

                if (field === "creaId") {
                  setErroCreaId(true);
                } else if (field === "agronomoId") {
                  setErroAgronomoId(true);
                } else if (field === "numero_art") {
                  setErroNumeroArt(true);
                } else if (field === "receita_inicial") {
                  setErroReceitaInicial(true);
                } else if (field === "quantidade_receitas") {
                  setErroQuantidadeContratos(true);
                }
              }

              if (typeof errors === "string") {
                if (errors.includes("ERRO-680")) {
                  setErroNumeroArt(true);
                }

                store.addNotification({
                  title: "Erro!",
                  message: apiErrorMessage,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 6000,
                    onScreen: true,
                  },
                });

                setLoading(false);
              } else {
                if (!numeroArt) {
                  setErroNumeroArt(true);
                }

                store.addNotification({
                  title: "Erro!",
                  message: validationErrorMessage,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 6000,
                    onScreen: true,
                  },
                });
              }

              setLoading(false);
            } catch (err) {
              store.addNotification({
                title: "Erro!",
                message: apiErrorMessage,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 6000,
                  onScreen: true,
                },
              });
              setLoading(false);
            }
          }
        }
      }
    } else {
      if (
        !creaId ||
        !agronomoId ||
        !numeroArt ||
        !receitaInicial ||
        !quantidadeReceita ||
        (!numeroOrdem && props.estado.value === "SP") ||
        (props.estado.value === "SP" &&
          numeroOrdem &&
          Number(numeroOrdem) >= quantidadeContratos) ||
        (!qtdReceitasEmitidas && props.estado.value === "NACIONAL")
      ) {
        if (!creaId) {
          setErroCreaId(true);
        }

        if (!agronomoId) {
          setErroAgronomoId(true);
        }

        if (!numeroArt || numeroArt === "") {
          setErroNumeroArt(true);
        }

        if (!receitaInicial) {
          setErroReceitaInicial(true);
        }

        if (!quantidadeReceita) {
          setErroQuantidadeContratos(true);
        }

        if (props.estado.value === "NACIONAL" || props.estado === "NACIONAL") {
          if (!qtdReceitasEmitidas) {
            setErroReceitasEmitidas(true);
          }
        }

        if (props.estado.value === "SP" || props.estado === "SP") {
          if (!numeroOrdem) {
            setErroNumeroOrdem(true);
          }
        }

        if (props.estado.value === "SP" || props.estado === "SP") {
          if (Number(numeroOrdem) >= quantidadeContratos) {
            setErroNumeroOrdem(true);

            store.addNotification({
              title: "Erro!",
              message: "Verifique os campos em vermelho para continuar.",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        } else {
          store.addNotification({
            title: "Erro!",
            message: "Preencha os campos em vermelho para continuar.",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 6000,
              onScreen: true,
            },
          });
        }

        setLoading(false);
        return;
      } else {
        // Checa duplicidade antes de criar (demais estados)
        const isDuplicate = await checkDuplicateArt(creaId, numeroArt, valor);
        if (isDuplicate) {
          setErroNumeroArt(true);
          store.addNotification({
            title: "Erro!",
            message: "Esse número de ART/TRT já existe para o CREA selecionado.",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 6000, onScreen: true },
          });
          setLoading(false);
          return;
        }

        const payload = {
          estado: valor,
          creaId: creaId.value || creaId,
          agronomoId: agronomoId.value || agronomoId,
          apelido: apelido || null,
          numero_art: numeroArt,
          quantidade_receitas: Number(quantidadeReceita),
          receita_inicial: receitaInicial,
          qtd_avisar: saldoArts ? saldoArts.value : null,
          qtd_receitas_emitidas: Number(qtdReceitasEmitidas),
          numero_ordem: numeroOrdem ? numeroOrdem : null,
          data_validade: dataValidade,
          // avisar: sendAlert ? 1 : 0
        };

        try {
          const response = await api.post(
            `/creas/${creaId.value || creaId}/arts`,
            payload
          );
          if (response.status === 200) {
            store.addNotification({
              title: "Sucesso!",
              message: "A ART/TRT foi cadastrado corretamente.",
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true,
              },
            });
          }

          if (props.isModal === true) {
            props.updateArt();
          } else {
            props.loc.history.push("/arts");
          }
        } catch (err) {
          const status = err.response?.status;
          const ERRO = err.response?.data?.errors;
          const apiErrorMessage = identifyErrorMenssage(
            err,
            "Erro ao cadastrar ART/TRT."
          );
          const validationErrorMessage = identifyErrorMenssage(
            err,
            "Verifique os campos em vermelho"
          );
          destacarCampoDoErroDaApi(ERRO);
          if (status === 406 || status === 400) {
            store.addNotification({
              title: "Erro!",
              message: apiErrorMessage,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
            setLoading(false);
          } else {
            try {
              let inputWithErrors = document.querySelectorAll(".error");

              for (let input of inputWithErrors) {
                // input.classList.remove("error");

                if (input === "creaId") {
                  setErroCreaId(false);
                } else if (input === "agronomoId") {
                  setErroAgronomoId(false);
                } else if (input === "numero_art") {
                  setErroNumeroArt(false);
                } else if (input === "receita_inicial") {
                  setErroReceitaInicial(false);
                } else if (input === "quantidade_receitas") {
                  setErroQuantidadeContratos(false);
                } else if (input === "numero_ordem") {
                  setErroNumeroOrdem(false);
                }
              }

              const errors = err.response?.data?.errors;

              for (let field in errors) {
                // const input = document.getElementById(field);
                // input.classList.add("error");

                if (field === "creaId") {
                  setErroCreaId(true);
                } else if (field === "agronomoId") {
                  setErroAgronomoId(true);
                } else if (field === "numero_art") {
                  setErroNumeroArt(true);
                } else if (field === "receita_inicial") {
                  setErroReceitaInicial(true);
                } else if (field === "quantidade_receitas") {
                  setErroQuantidadeContratos(true);
                }
              }

              if (typeof errors === "string") {
                store.addNotification({
                  title: "Erro!",
                  message: apiErrorMessage,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 6000,
                    onScreen: true,
                  },
                });

                if (
                  errors ===
                  'Para o tipo CFTA, o campo Número ART/TRT deve ser igual a 13 dígitos e conter os caracteres "BR".'
                ) {
                  setErroNumeroArt(true);
                }

                if (errors.includes("ERRO-680")) {
                  setErroNumeroArt(true);
                }

                if (
                  errors ===
                  'Para o tipo CFTA, o campo Receita Inicial deve ser igual a 16 dígitos e conter os caracteres "BR" e "RA".'
                ) {
                  setErroReceitaInicial(true);
                }

                setLoading(false);
              } else {
                store.addNotification({
                  title: "Erro!",
                  message: validationErrorMessage,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 6000,
                    onScreen: true,
                  },
                });
              }

              setLoading(false);
            } catch (err) {
              store.addNotification({
                title: "Erro!",
                message: apiErrorMessage,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 6000,
                  onScreen: true,
                },
              });
              setLoading(false);
            }
          }
        }
      }
      setLoading(false);
    }
  };

  const nextStep = async (e) => {
    // e.preventDefault();
    const estadoAtual = getEstadoAtual();
    const receitaInicialOk = isReceitaInicialValida(receitaInicial, estadoAtual);

    if (estadoAtual === "RS" && numeroArt && !isNumeroArtRsValido(numeroArt)) {
      setErroNumeroArt(true);
      store.addNotification({
        title: "Erro!",
        message: MENSAGEM_NUMERO_ART_RS,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 6000,
          onScreen: true,
        },
      });
      setLoading(false);
      return;
    }

    let inputWithErrors = document.querySelectorAll(".error");

    for (let input of inputWithErrors) {
      if (input === "creaId") {
        setErroCreaId(false);
      } else if (input === "agronomoId") {
        setErroAgronomoId(false);
      } else if (input === "numero_art") {
        setErroNumeroArt(false);
      } else if (input === "receita_inicial") {
        setErroReceitaInicial(false);
      } else if (input === "quantidade_receitas") {
        setErroQuantidadeContratos(false);
      }
    }

    if (
      !agronomoId ||
      !creaId ||
      !numeroArt ||
      !receitaInicial ||
      !receitaInicialOk ||
      !quantidadeContratos ||
      !numeroOrdem ||
      Number(numeroOrdem) >= quantidadeContratos
    ) {
      setLoading(false);

      if (
        !agronomoId ||
        !creaId ||
        !numeroArt ||
        !receitaInicial ||
        !receitaInicialOk ||
        !quantidadeContratos ||
        !numeroOrdem
      ) {
        store.addNotification({
          title: "Erro!",
          message: "Verifique os campos em vermelho",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 6000,
            onScreen: true,
          },
        });
      }

      if (!creaId) {
        setErroCreaId(true);
      }

      if (!agronomoId) {
        setErroAgronomoId(true);
      }

      if (!numeroArt || numeroArt.length === 0) {
        setErroNumeroArt(true);
      }

      if (!receitaInicial) {
        setErroReceitaInicial(true);
      }

      if (receitaInicial && !receitaInicialOk) {
        setErroReceitaInicial(true);
      }

      if (!quantidadeContratos) {
        setErroQuantidadeContratos(true);
      }

      if (!numeroOrdem) {
        setErroNumeroOrdem(true);
      }

      if (numeroOrdem && quantidadeContratos) {
        if (Number(numeroOrdem) >= quantidadeContratos) {
          setErroNumeroOrdem(true);

          store.addNotification({
            title: "Erro!",
            message:
              "O número da ordem não pode ser maior ou igual que a quantidade de contratos.",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 6000,
              onScreen: true,
            },
          });
        }
      }
    }

    const testArt = await testaArt();

    if (testArt) {
      if (
        agronomoId &&
        estadoId &&
        step &&
        creaId &&
        numeroArt &&
        receitaInicial &&
        receitaInicialOk &&
        quantidadeContratos &&
        numeroOrdem &&
        Number(numeroOrdem) < quantidadeContratos
      ) {
        update(
          agronomoId,
          estadoId,
          step,
          creaId,
          numeroArt,
          apelido,
          receitaInicial,
          quantidadeContratos,
          numeroOrdem,
          dataValidade
        );

        if (max.max_receitas || max.min_receitas) {
          if (quantidadeReceita && quantidadeReceita != "") {
            next();
          }
        } else if (max.max_contratos || max.min_contratos) {
          if (quantidadeContratos && quantidadeContratos != "") {
            next();
          }
        }
      } else if (
        agronomoId.value &&
        creaId.estado &&
        step &&
        creaId.value &&
        numeroArt &&
        receitaInicial &&
        quantidadeContratos &&
        numeroOrdem &&
        Number(numeroOrdem) < quantidadeContratos
      ) {
        update(
          agronomoId.value,
          creaId.estado,
          step,
          creaId.value,
          numeroArt,
          apelido,
          receitaInicial,
          quantidadeContratos,
          numeroOrdem,
          dataValidade
        );

        if (max.max_receitas || max.min_receitas) {
          if (quantidadeReceita && quantidadeReceita != "") {
            next();
          } else {
          }
        } else if (max.max_contratos || max.min_contratos) {
          if (quantidadeContratos && quantidadeContratos != "") {
            next();
          } else {
          }
        }
      }
    }
  };

  const changeSendAlert = (e) => {
    setSendAlert(e);
  };

  const changeDataValidade = (e) => {
    setDataValidade(e);
  };

  const validateNumeroArt = (numeroArt) => {
    setNumeroArt(numeroArt);
  };

  const blurNumeroArt = () => {
    const estadoAtual = (props.estado && props.estado.value) || props.estado;
    if (estadoAtual !== "RS") return;

    const valor = (numeroArt || "").trim();
    if (!valor) return;

    const valido = isNumeroArtRsValido(valor);
    setErroNumeroArt(!valido);
  };

  const getEstadoAtual = () =>
    (props.estado && props.estado.value) ||
    props.estado ||
    (estadoId && estadoId.value) ||
    estadoId ||
    (creaId && creaId.estado) ||
    "";

  // const estadosReceitaInicialAlfanumerica = new Set(["CE"]);

  const receitaInicialPrecisaSerAlfanumerica = (estado) => {
    if (!estado) return false;
    if (
      estadosReceitaInicialAlfanumerica &&
      typeof estadosReceitaInicialAlfanumerica.has === "function"
    ) {
      return estadosReceitaInicialAlfanumerica.has(estado);
    }
    return (
      Array.isArray(estadosReceitaInicialAlfanumerica) &&
      estadosReceitaInicialAlfanumerica.includes(estado)
    );
  };

  const isReceitaInicialValida = (value, estado) => {
    if (!value) return false;
    const trimmed = String(value).trim();
    // SC: somente números, no máximo 5 dígitos
    if (estado === "SC") return /^\d{1,5}$/.test(trimmed);
    if (receitaInicialPrecisaSerAlfanumerica(estado)) {
      if (!/^[a-zA-Z0-9]+$/.test(trimmed)) return false;
      if (estado === "AP") {
        return (
          trimmed.length >= 15 &&
          trimmed.startsWith("AP") &&
          trimmed.substring(8).startsWith("RA")
        );
      }
      return trimmed.length >= 16;
    }
    const parsed = parseInt(trimmed, 10);
    if (!Number.isNaN(parsed) && parsed > 0) return true;
    return /^[a-zA-Z0-9]+$/.test(trimmed);
  };

  const validateReceitaInicial = async (e) => {
    const value = e?.target?.value ?? e ?? "";
    const estadoAtual = (props.estado && props.estado.value) || props.estado;
    // SC: somente números, no máximo 5 dígitos — não permite letras
    if (estadoAtual === "SC") {
      const soNumeros = String(value).replace(/\D/g, "").slice(0, 5);
      setReceitaInicial(soNumeros);
      return;
    }
    if (/^[a-zA-Z0-9]*$/.test(value)) {
      setReceitaInicial(value);
    }
  };

  const validateNumeroOrdem = (numeroOrdem) => {
    if (/^\d*$/.test(numeroOrdem)) {
      setNumeroOrdem(numeroOrdem);
    }
  };
  const validateQuantidadeContratos = (quantidadeContratos) => {
    setQuantidadeContratos(quantidadeContratos);
    setErroQuantidadeContratos(false);
  };
  const validateQuantidadeReceita = (quantidadeReceita) => {
    let inputWithErrors = document.querySelectorAll(".error");

    for (let input of inputWithErrors) {
      input.classList.remove("error");
    }

    setQuantidadeReceita(quantidadeReceita);
  };

  const validateQtdTotalReceitas = (valor) => {
    setQtdReceitasEmitidas(valor);
  };

  const validateInterval = (valor) => {
    if (valor == 0) {
      setQuantidadeReceita("");

      setErroQuantidadeContratos(true);

      store.addNotification({
        title: "Erro!",
        message: "Informe um valor maior que 0",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 6000,
          onScreen: true,
        },
      });
    } else {
      if (max) {
        if (max.min_receitas && max.max_receitas) {
          if (valor < max.min_receitas || valor > max.max_receitas) {
            //Exibir erro: Valor está fora da faixa de valor permitida
            // alert("Valor está fora da faixa de valor permitida");
            setQuantidadeReceita("");
            setErroQuantidadeContratos(true);

            // const input = document.getElementById('quantidade_receitas');
            // input.classList.add("error");
            store.addNotification({
              title: "Erro!",
              message: "O valor está fora da faixa de valor permitida",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        } else if (max.min_receitas) {
          if (valor < max.min_receitas) {
            //Exibir erro: Valor digitado é menor que o valor mínimo permitido
            // alert("Valor digitado é menor que o valor mínimo permitido");
            setQuantidadeReceita("");
            // const input = document.getElementById('quantidade_receitas');
            // input.classList.add("error");
            setErroQuantidadeContratos(true);

            store.addNotification({
              title: "Erro!",
              message: "O valor digitado é menor que o valor mínimo permitido",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        } else if (max.max_receitas) {
          if (valor > max.max_receitas) {
            //Exibir erro: Valor digitado é maior que o valor maximo permitido
            // alert("Valor digitado é maior que o valor maximo permitido");
            setQuantidadeReceita("");
            setErroQuantidadeContratos(true);

            // const input = document.getElementById('quantidade_receitas');
            // input.classList.add("error");

            store.addNotification({
              title: "Erro!",
              message: "O valor digitado é maior que o valor maximo permitido",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        } else if (max.min_contratos && max.max_contratos) {
          if (valor < max.min_contratos || valor > max.max_contratos) {
            //Exibir erro: Valor está fora da faixa de valor permitida
            // alert("Valor está fora da faixa de valor permitida");
            setQuantidadeContratos("");
            setErroQuantidadeContratos(true);

            // const input = document.getElementById('quantidadeContratos');
            // input.classList.add("error");
            store.addNotification({
              title: "Erro!",
              message: "O valor está fora da faixa de valor permitida",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        } else if (max.min_contratos) {
          if (valor < max.min_contratos) {
            //Exibir erro: Valor digitado é menor que o valor mínimo permitido
            // alert("Valor digitado é menor que o valor mínimo permitido");
            setQuantidadeContratos("");
            // const input = document.getElementById('quantidadeContratos');
            // input.classList.add("error");

            setErroQuantidadeContratos(true);

            store.addNotification({
              title: "Erro!",
              message: "O valor digitado é menor que o valor mínimo permitido",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        } else {
          if (valor > max.max_contratos) {
            //Exibir erro: Valor digitado é maior que o valor maximo permitido
            // alert("Valor digitado é maior que o valor maximo permitido");
            setQuantidadeContratos("");
            setErroQuantidadeContratos(true);

            // const input = document.getElementById('quantidadeContratos');
            // input.classList.add("error");
            store.addNotification({
              title: "Erro!",
              message: "O valor digitado é maior que o valor maximo permitido",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 6000,
                onScreen: true,
              },
            });
          }
        }
      }
    }
  };

  const validatesao = () => {
    if (props.estado.value === "SP" || props.estado === "SP") {
      setPasso3(true);
      if (agronomoId) {
        if (creaId) {
          if (numeroArt) {
            if (isReceitaInicialValida(receitaInicial, getEstadoAtual())) {
              if (
                quantidadeContratos >= max.min_contratos &&
                quantidadeContratos <= max.max_contratos
              ) {
                if (numeroOrdem) {
                  setDisabled(false);
                } else {
                  setDisabled(true);
                }
              } else {
                setDisabled(true);
              }
            } else {
              setDisabled(true);
            }
          } else {
            setDisabled(true);
          }
        } else {
          setDisabled(true);
        }
      } else {
        setDisabled(true);
      }
    }
  };
  const validateNacional = () => {
    if (props.estado.value === "NACIONAL" || props.estado === "NACIONAL") {
      setPasso3(false);
      if (agronomoId) {
        if (creaId) {
          if (numeroArt) {
            if (receitaInicial) {
              // if (quantidadeContratos >= max.min_contratos && quantidadeContratos <= max.max_contratos) {
              if (
                quantidadeReceita >= max.min_receitas &&
                quantidadeReceita <= max.max_receitas
              ) {
                setDisabled(false);
              } else {
                setDisabled(true);
              }
              // } else {

              //     setDisabled(true);
              // }
            } else {
              setDisabled(true);
            }
          } else {
            setDisabled(true);
          }
        } else {
          setDisabled(true);
        }
      } else {
        setDisabled(true);
      }
    }
  };
  const validateforms = () => {
    if (
      props.estado.value !== "SP" &&
      props.estado !== "SP" &&
      (props.estado.value !== "NACIONAL" || props.estado !== "NACIONAL")
    ) {
      setPasso3(false);

      if (agronomoId) {
        if (creaId) {
          if (numeroArt) {
            if (isReceitaInicialValida(receitaInicial, getEstadoAtual())) {
              if (quantidadeReceita) {
                if (
                  quantidadeReceita > 0 &&
                  quantidadeReceita <= max.max_receitas
                ) {
                  setDisabled(false);
                } else {
                  setDisabled(true);
                }
              } else {
                setDisabled(true);
              }
            } else {
              setDisabled(true);
            }
          } else {
            setDisabled(true);
          }
        } else {
          setDisabled(true);
        }
      } else {
        setDisabled(true);
      }
    }
  };

  const addModalAgronomo = () => {
    setModalAgronomoShow(true);
  };
  const addModalClose = (e) => {
    // e.preventDefault();

    if (modalAgronomoShow == true) {
      setModalAgronomoShow(false);
    }

    if (modalCreaShow == true) {
      setModalCreaShow(false);
    }
  };
  const modalClose = (e) => {
    if (showModal == true) {
      setShowModal(false);
    }

    if (showModal2 == true) {
      setShowModal2(false);
    }
  };

  const openModalText = (e) => {
    setShowModal(true);
  };

  const openModalText2 = (e) => {
    setShowModal2(true);
  };

  const openModalTextValidade = (e) => {
    setShowModalValidade(true);
  };

  const updateIdAgronomo = async () => {
    // setNomeId(nomeId);
    // setCpfId(cpfId);
    setModalAgronomoShow(false);
    // setModalCreaShow(true);

    getAgronomos(props.estado.value || props.estado);
    setAgronomoId("");

    //FALTA RECARREGAR CAMPO AGRONOMOS TODA VEZ QUE CRIAR UM NOVO PELO MODAL
  };

  const updateCrea = async (e) => {
    setModalCreaShow(false);

    getAgronomos(props.estado.value || props.estado);
    // getCreas();
  };

  const validaAgronomo = (valor) => {
    if (valor !== agronomoId) {
      setAgronomoId(valor);
    }
  };

  useEffect(() => {
    if (props.isModal != true) {
      window.scrollTo(0, 0);
    }

    if (props.isModal === true && props.agronomo && props.crea) {
      setAgronomoId(props.agronomo);
      setCreaId(props.crea);
    }

    let state =
      props.isModal != true
        ? props.estado.value || props.estado
        : props.crea.estado;

    getAgronomos(state);
    getMax(state);
    setEstado(state);

    if (state === "SP") {
      setPasso3(true);
    }

    if (state === "NACIONAL") {
      let now = new Date();

      let d1 = now.getDate();
      let m1 = now.getMonth();
      let y1 = now.getFullYear();
      m1 = m1 + 1;

      if (m1 <= 9) {
        m1 = `0${m1}`;
      }

      setPlaceholderCFTA(`Ex: BR${y1}${m1}RA000001`);
      setPlaceholderTRT(`Ex: BR${y1}${m1}00001`);
    }

    setApelido(props.apelido || "");
  }, []);

  useEffect(() => {
    const prop_estado = props.estado.value
      ? props.estado.value || props.estado
      : props.estado;
    if (prop_estado && agronomoId) {
      getCreas(agronomoId, prop_estado);
    }
  }, [agronomoId]);

  useEffect(() => {
    if (props.isModal === false) {
      if (estadoId.value !== "SP") {
        if (receitaInicial > max.max_receitas) {
          setValorInformacao(
            `O numero Limite de receitas é ${max.max_receitas}`
          );
        }
      }
      if (estadoId.value !== "SP") {
        if (receitaInicial < max.max_receitas) {
          setValorInformacao(``);
        }
      }
    } else {
      let e = props.estado.value || props.estado;
      if (e !== "SP") {
        if (receitaInicial > max.max_receitas) {
          setValorInformacao(
            `O numero Limite de receitas é ${max.max_receitas}`
          );
        }
      }
      if (e !== "SP") {
        if (receitaInicial < max.max_receitas) {
          setValorInformacao(``);
        }
      }
    }
  }, [receitaInicial, quantidadeReceita]);
  useEffect(() => {
    // validaMinas();
    validatesao();
    validateNacional();
    validateforms();

    if (saldoArts) {
      setInativoSaldoArt(false);
    } else {
      setInativoSaldoArt(false);
    }

    if (agronomoId && erroAgronomoId === true) {
      setErroAgronomoId(false);
    }
    if (creaId && erroCreaId === true) {
      setErroCreaId(false);
    }
    if (numeroArt && erroNumeroArt === true) {
      setErroNumeroArt(false);
    }
    if (receitaInicial && erroReceitaInicial === true) {
      setErroReceitaInicial(false);
    }

    if (quantidadeContratos && erroQuantidadeContratos === true) {
      setErroQuantidadeContratos(false);
    }
    if (quantidadeReceita && erroQuantidadeContratos === true) {
      setErroQuantidadeContratos(false);
    }
  }, [
    agronomoId,
    creaId,
    numeroArt,
    receitaInicial,
    quantidadeContratos,
    quantidadeReceita,
  ]);

  useEffect(() => {
    if (numeroOrdem && erroNumeroOrdem === true) {
      setErroNumeroOrdem(false);
    }
  }, [numeroOrdem]);

  useEffect(() => {
    if (props.estado.value === "SP" || props.estado === "SP") {
      if (quantidadeContratos > 300) {
        setLegendaQuantidade("Não é permitido mais do que 300 contratos.");
      } else if (quantidadeContratos < 52 && quantidadeContratos !== "") {
        setLegendaQuantidade("Não é permitido menos do que 52 contratos.");
      } else {
        if (max) {
          if (max.min_contratos == null || max.min_contratos == 0) {
            setLegendaQuantidade(
              `De 1 a ${max.max_contratos || "Não há"} contratos`
            );
          } else {
            setLegendaQuantidade(
              `Informe a quantidade de Contratos que foram adquiridos na compra desta ART. Insira um valor entre ${max.min_contratos
              } a ${max.max_contratos || "Não há"}.`
            );
          }
        }
      }
    } else {
      if (max.min_receitas) {
        setLegendaQuantidade(
          `Informe a quantidade de Receitas que foram adquiridas na compra desta ${props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "TRT"
            : "ART"
          }. Insira um valor entre ${max.min_receitas} a ${max.max_receitas || "Não há"
          }.`
        );
      } else {
        setLegendaQuantidade(
          `Informe a quantidade de Receitas que foram adquiridas na compra desta ${props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "TRT"
            : "ART"
          }. Insira um valor entre 1 a ${max.max_receitas || "Não há"}.`
        );
      }
    }
  }, [quantidadeContratos, max]);

  const exibeCamposPlaceholder = (
    <>
      <Input
        name="apelido"
        label="Apelido"
        type="text"
        id="apelido"
        value={apelido}
        onChange={(e) => setApelido(e)}
        marginBottom="0"
      />

      <Input
        height="auto"
        marginBottom={
          props.estado.value === "SP" ||
            props.estado.value === "NACIONAL" ||
            props.estado === "SP" ||
            props.estado === "NACIONAL"
            ? "28px"
            : "14px"
        }
        name="numeroArt"
        type="text"
        id="numero_art"
        label="Número ART/TRT"
        labelWithAsterisk={true}
        // label={placeholderTrt}
        onChange={(e) => validateNumeroArt(e)}
        onBlur={blurNumeroArt}
        value={numeroArt}
        // help={true}
        // helpClick={() => openModalText2()}
        erro={erroNumeroArt}
        legenda={
          props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "O número da TRT deve seguir o formato correto. Ex.: BR20200200001."
            : (props.estado.value === "RS" || props.estado === "RS")
            ? MENSAGEM_NUMERO_ART_RS
            : ""
        }
      />

      {props.estado.value === "SP" ||
        props.estado.value === "NACIONAL" ||
        props.estado === "SP" ||
        props.estado === "NACIONAL" ? (
        <Input
          marginBottom={
            props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
              ? "8px"
              : "14px"
          }
          name="validade-art"
          type="date"
          label="Data de validade"
          id="validade_art"
          onChange={(e) => changeDataValidade(e)}
          value={dataValidade}
          erro={""}
          mask="99/99/9999"
          help={true}
          helpClick={() => openModalTextValidade()}
        />
      ) : null}

      {props.estado.value === "NACIONAL" || props.estado === "NACIONAL" ? (
        <Input
          marginBottom="35px"
          name="quantidade-receitas"
          type="number"
          min={max.min_receitas}
          max={max.max_receitas}
          label="Receitas adquiridas"
          labelWithAsterisk={true}
          id="quantidade_receitas"
          onChange={(e) =>
            e ? validateQuantidadeReceita(e) : validateQuantidadeReceita("")
          }
          onBlur={(e) => validateInterval(e.target.value)}
          value={quantidadeReceita}
          erro={erroQuantidadeContratos}
          legenda={legendaQuantidade}
        />
      ) : null}

      <Input
        marginBottom={
          props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "35px"
            : "24px"
        }
        name="quantidadeReceitas"
        type="number"
        label="Receitas já utilizadas"
        labelWithAsterisk={true}
        id="qtd_receita_emitida"
        onChange={(e) => validateQtdTotalReceitas(e)}
        value={qtdReceitasEmitidas}
        erro={erroReceitasEmitidas}
        legenda={
          props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "Informe a quantidade de Receitas que já foram utilizadas nesta TRT até o momento. Se nenhuma Receita foi utilizada nesta TRT, insira o número 0."
            : ""
        }
      />

      <Input
        name="receitaInicial"
        type="text"
        label="Número da Receita inicial"
        labelWithAsterisk={true}
        // label={placeholderCfta}
        id="receita_inicial"
        onChange={(e) => validateReceitaInicial(e)}
        value={receitaInicial}
        // help={true}
        // helpClick={() => openModalText()}
        erro={erroReceitaInicial}
        marginBottom={
          props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "35px"
            : "14px"
        }
        legenda={
          props.estado.value === "NACIONAL" || props.estado === "NACIONAL"
            ? "Informe o número da primeira Receita desta TRT. EX: BR202002RA000001."
            : (props.estado.value === "MS" || props.estado === "MS")
            ? "Informe o número da primeira Receita desta ART. EX: B00522025021670."
            : (["SC", "ES", "GO"].includes(props.estado.value) || ["SC", "ES", "GO"].includes(props.estado))
            ? "Informe o número da primeira Receita desta ART. Somente números, no máximo 5 dígitos. Ex: 1."
            : (props.estado.value === "RS" || props.estado === "RS")
            ? `Informe o número da primeira Receita que será emitida no AgroReceita. Veja um exemplo: ${getEstadoAtual()}00001, ou somente números, ex: 0000001.`
            : (getEstadoAtual() && estadosReceitaInicialAlfanumerica.includes(getEstadoAtual()))
            ? `Informe o número da primeira Receita desta ART. EX: ${getEstadoAtual()}202601RA000001`
            : "Ex: Se você já emitiu 20 receitas com esta ART, coloque aqui 21."
        }
      // mask={props.estado.value == 'NACIONAL'? (`BR999999RA999999`):("")}
      />
    </>
  );

  const exibeCampos = (
    <>
      <Input
        name="apelido"
        label="Apelido"
        type="text"
        id="apelido"
        value={apelido}
        onChange={(e) => setApelido(e)}
        marginBottom="0"
      />

      <Input
        marginBottom={
          props.estado.value === "SP" ||
            props.estado.value === "NACIONAL" ||
            props.estado === "SP" ||
            props.estado === "NACIONAL"
            ? " 14px"
            : "14px"
        }
        name="numeroArt"
        type="text"
        id="numero_art"
        label="Número ART/TRT"
        labelWithAsterisk={true}
        onChange={(e) => validateNumeroArt(e)}
        onBlur={blurNumeroArt}
        value={numeroArt}
        erro={erroNumeroArt}
        legenda={
          (props.estado.value === "RS" || props.estado === "RS")
            ? MENSAGEM_NUMERO_ART_RS
            : ""
        }
      // onBlur={testaArt}
      />

      {/* {props.estado.value === "SP" || props.estado.value === "NACIONAL" || props.estado === 'SP' || props.estado === 'NACIONAL' ? ( */}
      <Input
        marginBottom="14px"
        name="validade-art"
        type="date"
        label="Data de validade"
        id="validade_art"
        onChange={(e) => changeDataValidade(e)}
        value={dataValidade}
        erro={""}
        mask="99/99/9999"
        help={true}
        helpClick={() => openModalTextValidade()}
      />
      {/* ) : null} */}
    </>
  );

  return (
    <>
      <FormContainer {...props}>
        <Container>
          {props.isModal === true ? null : (
            <div className="steps">
              <div className="btn-step">
                <label>1</label>
              </div>

              <div className="btn-step-selected">
                <label>2</label>
              </div>
              {props.estado.value === "SP" || props.estado === "SP" ? (
                <div className="btn-step">
                  <label>3</label>
                </div>
              ) : null}
            </div>
          )}

          <Row>
            <Col>
              <form>
                <Select
                  height="auto"
                  marginBottom="42px"
                  name="agronomo"
                  className="select"
                  label={`Responsável Técnico`}
                  labelWithAsterisk={true}
                  id="agronomoId"
                  disabled={false}
                  onChange={(e) => validaAgronomo(e)}
                  options={agronomos}
                  value={agronomoId.value || agronomoId}
                  selectUniqueOption={true}
                  buttonAddNew={true}
                  onClickAddNew={() => addModalAgronomo()}
                  erro={erroAgronomoId}
                  isModal={props.isModal}
                  isTotvs={isTotvs()}
                />

                <Select
                  height="auto"
                  marginBottom="42px"
                  name="creas"
                  className="select"
                  label="CREA/Visto/CFTA"
                  labelWithAsterisk={true}
                  id="creaId"
                  onChange={(creaId) =>
                    creaId ? setCreaId(creaId.value) : setCreaId("")
                  }
                  value={creaId.value || creaId}
                  options={creas}
                  disabled={false}
                  selectUniqueOption={true}
                  erro={erroCreaId}
                />

                {!placeholderTrt && !placeholderCfta ? (
                  <>{exibeCampos}</>
                ) : (
                  <>{exibeCamposPlaceholder}</>
                )}

                {passo3 == true ? (
                  <>
                    {/* {teste} */}
                    {max.min_contratos == null ? (
                      <Input
                        marginBottom="24px"
                        name="quantidadeContratos"
                        type="number"
                        min={1}
                        max={max.max_contratos}
                        id="quantidadeContratos"
                        label="Contratos adquiridos"
                        labelWithAsterisk={true}
                        onChange={(e) =>
                          e
                            ? validateQuantidadeContratos(e)
                            : validateQuantidadeContratos("")
                        }
                        onBlur={(e) => validateInterval(e.target.value)}
                        value={quantidadeContratos}
                        erro={erroQuantidadeContratos}
                        legenda={legendaQuantidade}
                      />
                    ) : (
                      <Input
                        marginBottom="24px"
                        name="quantidadeContratos"
                        type="number"
                        min={max.min_contratos}
                        max={max.max_contratos}
                        id="quantidadeContratos"
                        label="Contratos adquiridos"
                        labelWithAsterisk={true}
                        value={quantidadeContratos}
                        onChange={(e) =>
                          e
                            ? validateQuantidadeContratos(e)
                            : validateQuantidadeContratos("")
                        }
                        onBlur={(e) => validateInterval(e.target.value)}
                        erro={erroQuantidadeContratos}
                        legenda={legendaQuantidade}
                      />
                    )}

                    {props.estado.value === "SP" ||
                      props.estado.value === "NACIONAL" ||
                      props.estado === "SP" ||
                      props.estado === "NACIONAL" ? (
                      <Input
                        marginBottom="38px"
                        name="numeroOrdem"
                        type="text"
                        id="numeroOrdem"
                        label="Contratos já utilizados"
                        labelWithAsterisk={true}
                        maxlength={6}
                        onChange={(e) => validateNumeroOrdem(e)}
                        erro={erroNumeroOrdem}
                        value={numeroOrdem}
                        legenda="Informe a quantidade de Contratos que já foram utilizadas nesta ART até o momento. Se nenhum Contrato foi utilizado nesta ART, insira o número 0."
                      />
                    ) : null}

                    {!placeholderTrt && !placeholderCfta ? (
                      <Input
                        name="receitaInicial"
                        type="text"
                        label="Número da Receita inicial"
                        labelWithAsterisk={true}
                        id="receita_inicial"
                        onChange={(e) => validateReceitaInicial(e)}
                        value={receitaInicial}
                        erro={erroReceitaInicial}
                        marginBottom="24px"
                        legenda={props.estado.value === "NACIONAL" || props.estado === "NACIONAL" ? ""
                          : (() => {
                              const estadoAtual =(
                                props.estado && props.estado.value) || props.estado;

                              if (estadoAtual === "MS") {
                                return "Informe o número da primeira Receita desta ART. EX: B00522025021670.";
                              }
                              if (["SC", "ES", "GO"].includes(estadoAtual)) {
                                return "Informe o número da primeira Receita desta ART. Somente números, no máximo 5 dígitos. Ex: 1.";
                              }
                              if (estadoAtual === "RS") {
                                return `Informe o número da primeira Receita que será emitida no AgroReceita. Veja um exemplo: ${estadoAtual}00001, ou somente números, ex: 0000001.`;
                              }
                              if (estadoAtual  && estadosReceitaInicialAlfanumerica.includes(estadoAtual)) {
                                return `Informe o número da primeira Receita desta ART. EX: ${estadoAtual}202601RA000001`; 
                              }

                              return `Informe o número da primeira Receita desta ART. EX: ${estadoAtual}202601RA000001, ou somente números, ex: 1.`;
                            })()
                      }
                      // mask={props.estado.value == 'NACIONAL'? (`BR999999RA999999`):("")}
                      />
                    ) : (
                      ""
                    )}

                    {props.estado.value === "SP" ||
                      props.estado.value === "NACIONAL" ||
                      props.estado === "SP" ||
                      props.estado === "NACIONAL" ? null : (
                      <Input
                        name="validade-art"
                        type="date"
                        label="Data de validade"
                        id="validade_art"
                        onChange={(e) => changeDataValidade(e)}
                        value={dataValidade}
                        erro={""}
                        mask="99/99/9999"
                        help={true}
                        helpClick={() => openModalTextValidade()}
                        marginBottom="0"
                      />
                    )}

                    <div
                      className="button-finish"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginTop: "15px",
                        marginBottom: "0px",
                      }}
                    >
                      <Button
                        width="100%"
                        height="50px"
                        value="AVANÇAR"
                        outline={true}
                        disabled={false}
                        onClick={() => nextStep()}
                        loading={false}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {max ? (
                      <>
                        {max.min_receitas && max.max_receitas ? (
                          <>
                            {props.estado.value === "NACIONAL" || props.estado === "NACIONAL" ? null : (
                              <>
                                <Input
                                  marginBottom="35px"
                                  name="quantidade-receitas"
                                  type="number"
                                  min={max.min_receitas}
                                  max={max.max_receitas}
                                  label="Receitas adquiridas"
                                  labelWithAsterisk={true}
                                  id="quantidade_receitas"
                                  onChange={(e) =>
                                    e ? validateQuantidadeReceita(e) : validateQuantidadeReceita("")
                                  }
                                  onBlur={(e) => validateInterval(e.target.value)}
                                  value={quantidadeReceita}
                                  erro={erroQuantidadeContratos}
                                  legenda={legendaQuantidade}
                                />

                                <Input
                                  marginBottom="30px"
                                  name="quantidadeReceitas"
                                  type="number"
                                  label="Receitas já utilizadas"
                                  labelWithAsterisk={true}
                                  id="qtd_receita_emitida"
                                  onChange={(e) => validateQtdTotalReceitas(e)}
                                  value={qtdReceitasEmitidas}
                                  legenda="Informe a quantidade de Receitas que já foram utilizadas nesta ART até o momento. Se nenhuma Receita foi utilizada nesta ART, insira o número 0."
                                />
                              </>
                            )}

                            {props.estado.value === "SP" ||
                              props.estado.value === "NACIONAL" ||
                              props.estado === "SP" ||
                              props.estado === "NACIONAL" ? null : (
                              <Input
                                name="receitaInicial"
                                type="text"
                                label="Número da Receita inicial"
                                labelWithAsterisk={true}
                                id="receita_inicial"
                                onChange={(e) => validateReceitaInicial(e)}
                                value={receitaInicial}
                                erro={erroReceitaInicial}
                                marginBottom="28px"
                                legenda={props.estado.value === "NACIONAL" || props.estado === "NACIONAL" ? ""
                                    : (() => {
                                        const estadoAtual =(
                                          props.estado && props.estado.value) || props.estado;

                                        if (estadoAtual === "MS") {
                                          return "Informe o número da primeira Receita desta ART. EX: B00522025021670.";
                                        }
                                        if (["SC", "ES", "GO"].includes(estadoAtual)) {
                                          return "Informe o número da primeira Receita desta ART. Somente números, no máximo 5 dígitos. Ex: 1.";
                                        }
                                        if (estadoAtual === "RS") {
                                          return `Informe o número da primeira Receita que será emitida no AgroReceita. Veja um exemplo: ${estadoAtual}00001, ou somente números, ex: 0000001.`;
                                        }
                                        if (estadoAtual  && estadosReceitaInicialAlfanumerica.includes(estadoAtual)) {
                                          return `Informe o número da primeira Receita desta ART. EX: ${estadoAtual}202601RA000001`; 
                                        }

                                        return `Informe o número da primeira Receita desta ART. EX: ${estadoAtual}202601RA000001, ou somente números, ex: 1.`;
                                      })()
                                }
                              />
                            )}

                            <Select
                              marginBottom="44px"
                              name="saldoArts"
                              className="select"
                              label="Me avisar quando o saldo estiver a partir de:"
                              id="saldoArts"
                              value={saldoArts}
                              disabled={!sendAlert}
                              loading={false}
                              erro={false}
                              onChange={(e) => setSaldoArts(e)}
                              options={[
                                { value: 5, label: "5 receitas para acabar" },
                                { value: 10, label: "10 receitas para acabar" },
                                { value: 15, label: "15 receitas para acabar" },
                              ]}
                              yesNo={true}
                              yesNoValue={sendAlert}
                              messageYesNo="Quero receber notificações"
                              onChangeYesNo={(e) => changeSendAlert(e)}
                              yesNoLeft="350px"
                              showDisabledYesNo={true}
                            />
                          </>
                        ) : (
                          <>
                            {max.max_receitas ? (
                              <>
                                {props.estado.value === "NACIONAL" || props.estado === "NACIONAL" ? null : (
                                  <>
                                    <Input
                                      marginBottom="35px"
                                      name="quantidade-receitas"
                                      type="number"
                                      min={1}
                                      max={max.max_receitas}
                                      label="Receitas adquiridas"
                                      labelWithAsterisk={true}
                                      id="quantidade_receitas"
                                      onChange={(e) =>
                                        e
                                          ? validateQuantidadeReceita(e)
                                          : validateQuantidadeReceita("")
                                      }
                                      value={quantidadeReceita}
                                      onBlur={(e) =>
                                        validateInterval(e.target.value)
                                      }
                                      erro={erroQuantidadeContratos}
                                      legenda={legendaQuantidade}
                                    />

                                    <Input
                                      marginBottom="30px"
                                      name="quantidadeReceitas"
                                      type="number"
                                      label="Receitas já utilizadas"
                                      labelWithAsterisk={true}
                                      id="qtd_receita_emitida"
                                      onChange={(e) => validateQtdTotalReceitas(e)}
                                      value={qtdReceitasEmitidas}
                                      legenda="Informe a quantidade de Receitas que já foram utilizadas nesta ART até o momento. Se nenhuma Receita foi utilizada nesta ART, insira o número 0."
                                    />
                                  </>
                                )}
                                

                                {props.estado.value === "SP" ||
                                  props.estado.value === "NACIONAL" ||
                                  props.estado === "SP" ||
                                  props.estado === "NACIONAL" ? null : (
                                  <Input
                                    name="receitaInicial"
                                    type="text"
                                    label="Número da Receita inicial"
                                    labelWithAsterisk={true}
                                    id="receita_inicial"
                                    onChange={(e) => validateReceitaInicial(e)}
                                    value={receitaInicial}
                                    erro={erroReceitaInicial}
                                    marginBottom="28px"
                                    legenda={props.estado.value === "NACIONAL" || props.estado === "NACIONAL" ? ""
                                        : (() => {
                                            const estadoAtual =(
                                              props.estado && props.estado.value) || props.estado;

                                            if (estadoAtual === "MS") {
                                              return "Informe o número da primeira Receita desta ART. EX: B00522025021670.";
                                            }
                                            if (["SC", "ES", "GO"].includes(estadoAtual)) {
                                              return "Informe o número da primeira Receita desta ART. Somente números, no máximo 5 dígitos. Ex: 1.";
                                            }
                                            if (estadoAtual === "RS") {
                                              return `Informe o número da primeira Receita que será emitida no AgroReceita. Veja um exemplo: ${estadoAtual}00001, ou somente números, ex: 0000001.`;
                                            }
                                            if (estadoAtual  && estadosReceitaInicialAlfanumerica.includes(estadoAtual)) {
                                              return `Informe o número da primeira Receita desta ART. EX: ${estadoAtual}202601RA000001`; 
                                            }

                                            return `Informe o número da primeira Receita desta ART. EX: ${estadoAtual}202601RA000001, ou somente números, ex: 1.`;
                                          })()
                                    }
                                  />
                                )}

                                <Select
                                  marginBottom="44px"
                                  name="saldoArts"
                                  className="select"
                                  label="Me avisar quando o saldo estiver a partir de:"
                                  id="saldoArts"
                                  value={saldoArts}
                                  disabled={!sendAlert}
                                  loading={false}
                                  erro={false}
                                  onChange={(e) => setSaldoArts(e)}
                                  options={[
                                    {
                                      value: 5,
                                      label: "5 receitas para acabar",
                                    },
                                    {
                                      value: 10,
                                      label: "10 receitas para acabar",
                                    },
                                    {
                                      value: 15,
                                      label: "15 receitas para acabar",
                                    },
                                  ]}
                                  yesNo={true}
                                  yesNoValue={sendAlert}
                                  messageYesNo="Quero receber notificações"
                                  onChangeYesNo={(e) => changeSendAlert(e)}
                                  yesNoLeft="350px"
                                  showDisabledYesNo={true}
                                />
                              </>
                            ) : (
                              <>
                                {max.min_receitas ? (
                                  <>
                                    <Input
                                      marginBottom="24px"
                                      name="quantidade-receitas"
                                      type="number"
                                      min={max.min_receitas}
                                      label="Quantidade de Receitas"
                                      labelWithAsterisk={true}
                                      id="quantidade_receitas"
                                      onChange={(e) =>
                                        e
                                          ? validateQuantidadeReceita(e)
                                          : validateQuantidadeReceita("")
                                      }
                                      value={quantidadeReceita}
                                      onBlur={(e) =>
                                        validateInterval(e.target.value)
                                      }
                                      erro={erroQuantidadeContratos}
                                      legenda={legendaQuantidade}
                                    />

                                    <Select
                                      marginBottom="44px"
                                      name="saldoArts"
                                      className="select"
                                      label="Me avisar quando o saldo estiver a partir de:"
                                      id="saldoArts"
                                      value={saldoArts}
                                      disabled={!sendAlert}
                                      loading={false}
                                      erro={false}
                                      onChange={(e) => setSaldoArts(e)}
                                      options={[
                                        {
                                          value: 5,
                                          label: "5 receitas para acabar",
                                        },
                                        {
                                          value: 10,
                                          label: "10 receitas para acabar",
                                        },
                                        {
                                          value: 15,
                                          label: "15 receitas para acabar",
                                        },
                                      ]}
                                      yesNo={true}
                                      yesNoValue={sendAlert}
                                      messageYesNo="Quero receber notificações"
                                      onChangeYesNo={(e) => changeSendAlert(e)}
                                      yesNoLeft="350px"
                                      showDisabledYesNo={true}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {max.min_contratos == null ? (
                                      <Input
                                        name="quantidadeContratos"
                                        type="number"
                                        min={1}
                                        max={max.max_contratos}
                                        id="quantidadeContratos"
                                        label="Contratos adquiridos"
                                        labelWithAsterisk={true}
                                        onChange={(e) =>
                                          e
                                            ? validateQuantidadeContratos(e)
                                            : validateQuantidadeContratos("")
                                        }
                                        onBlur={(e) =>
                                          validateInterval(e.target.value)
                                        }
                                        value={quantidadeContratos}
                                        erro={erroQuantidadeContratos}
                                        legenda={legendaQuantidade}
                                        marginBottom="22px"
                                      />
                                    ) : (
                                      <Input
                                        name="quantidadeContratos"
                                        type="number"
                                        min={max.min_contratos}
                                        max={max.max_contratos}
                                        id="quantidadeContratos"
                                        label="Contratos adquiridos"
                                        labelWithAsterisk={true}
                                        value={quantidadeContratos}
                                        onChange={(e) =>
                                          e
                                            ? validateQuantidadeContratos(e)
                                            : validateQuantidadeContratos("")
                                        }
                                        onBlur={(e) =>
                                          validateInterval(e.target.value)
                                        }
                                        erro={erroQuantidadeContratos}
                                        legenda={legendaQuantidade}
                                        marginBottom="22px"
                                      />
                                    )}

                                    {props.estado.value === "SP" ||
                                      props.estado.value === "NACIONAL" ||
                                      props.estado === "SP" ||
                                      props.estado === "NACIONAL" ? (
                                      <>
                                        <Input
                                          name="numeroOrdem"
                                          type="text"
                                          id="numeroOrdem"
                                          label="Contratos já utilizados"
                                          labelWithAsterisk={true}
                                          maxlength={6}
                                          onChange={(e) =>
                                            validateNumeroOrdem(e)
                                          }
                                          erro={erroNumeroOrdem}
                                          value={numeroOrdem}
                                          marginBottom="36px"
                                          legenda="Informe a quantidade de Contratos que já foram utilizadas nesta ART até o momento. Se nenhum Contrato foi utilizado nesta ART, insira o número 0."
                                        />

                                        <Input
                                          name="validade-art"
                                          type="date"
                                          label="Data de validade"
                                          labelWithAsterisk={true}
                                          id="validade_art"
                                          onChange={(e) =>
                                            changeDataValidade(e)
                                          }
                                          value={dataValidade}
                                          erro={""}
                                          mask="99/99/9999"
                                          help={true}
                                          helpClick={() =>
                                            openModalTextValidade()
                                          }
                                          marginBottom="12px"
                                        />
                                      </>
                                    ) : null}

                                    <Select
                                      marginBottom="44px"
                                      name="saldoArts"
                                      className="select"
                                      label="Me avisar quando o saldo estiver a partir de:"
                                      id="saldoArts"
                                      value={saldoArts}
                                      disabled={!sendAlert}
                                      loading={false}
                                      erro={false}
                                      onChange={(e) => setSaldoArts(e)}
                                      options={[
                                        {
                                          value: 5,
                                          label: "5 receitas para acabar",
                                        },
                                        {
                                          value: 10,
                                          label: "10 receitas para acabar",
                                        },
                                        {
                                          value: 15,
                                          label: "15 receitas para acabar",
                                        },
                                      ]}
                                      yesNo={true}
                                      yesNoValue={sendAlert}
                                      messageYesNo="Quero receber notificações"
                                      onChangeYesNo={(e) => changeSendAlert(e)}
                                      yesNoLeft="350px"
                                      showDisabledYesNo={true}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : null}

                    <div
                      className="button-finish"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <Button
                        width="100%"
                        height="50px"
                        value="CADASTRAR"
                        outline={false}
                        disabled={false}
                        onClick={() => handlePost()}
                        loading={loading}
                      />
                    </div>
                  </>
                )}
              </form>

              <ModalText
                show={showModal}
                onHide={modalClose}
                text={
                  "Se você faz parte do CFTA, Ao  adquirir  uma  TRT, você recebeu um número como este “BR202002RA000001”. Insira este número no campo Receita Inicial."
                }
                btnOk={false}
              />

              <ModalText
                show={showModal2}
                onHide={modalClose}
                text={
                  "Se você faz parte do CFTA, Ao  adquirir  uma  TRT, você recebeu um número como este “BR20200200001”. Insira este número no campo ART/TRT."
                }
                btnOk={false}
              />

              <ModalText
                show={showModalValidade}
                onHide={() => setShowModalValidade(false)}
                text={
                  "Este campo não é obrigatório! Coloque a data de validade da ART se você desejar que ela inative automaticamente após a data informada."
                }
                btnOk={false}
              />

              <Modal
                show={modalAgronomoShow}
                onHide={() => addModalClose()}
                size="lg"
              >
                <AddAgronomo isModal={true} update={() => updateIdAgronomo()} />
              </Modal>
            </Col>
          </Row>
        </Container>
      </FormContainer>
    </>
  );
};
export default ArtsOne;
